export enum Bedrooms {
  STUDIO = 'Studios',
  ONE = '1 bed',
  TWO = '2 beds',
  THREE = '3 beds',
  FOURPLUS = '4 beds +',
  ALL = 'All beds',
}
